import { render, staticRenderFns } from "./ChooseRequestTypeSoa.vue?vue&type=template&id=ce8ea15a&"
import script from "./ChooseRequestTypeSoa.vue?vue&type=script&lang=js&"
export * from "./ChooseRequestTypeSoa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports